export default class Encryptor {

    public static async encrypt(value: string): Promise<string> {
        const iv = crypto.getRandomValues(new Uint8Array(12));
        const key = await this.getKey();
        const encoded = new TextEncoder().encode(value);
        const ciphertext = await crypto.subtle.encrypt(
            {name: 'AES-GCM', iv},
            key,
            encoded
        );

        const combined = new Uint8Array(iv.byteLength + ciphertext.byteLength);
        combined.set(iv);
        combined.set(new Uint8Array(ciphertext), iv.byteLength);
        return btoa(String.fromCharCode(...combined));
    }

    public static async decrypt(ciphertextBase64: string): Promise<string> {
        const combined = Uint8Array.from(atob(ciphertextBase64), c => c.charCodeAt(0));
        const iv = combined.slice(0, 12);
        const ciphertext = combined.slice(12);
        const key = await this.getKey();

        const decrypted = await crypto.subtle.decrypt(
            {name: 'AES-GCM', iv},
            key,
            ciphertext
        );

        return new TextDecoder().decode(decrypted);
    }

    private static async getKey(): Promise<CryptoKey> {
        const enc = new TextEncoder();
        const keyData = enc.encode(process.env.VUE_APP_ENCRYPTOR_KEY.padEnd(32, '_').slice(0, 32));
        return crypto.subtle.importKey(
            'raw',
            keyData,
            {name: 'AES-GCM'},
            false,
            ['encrypt', 'decrypt']
        );
    }
}
